export const domainMaterial =
{
  "DI": "Ductile Iron",
  "CI": "Cast Iron",
  "PVC": "Poly Vinyl Chloride",
  "AC": "Asbestos Cement",
  "HDPE": "High Density Polyethylene",
  "CO": "Copper",
  "MS": "Mild Steel",
  "UPVC": "UPVC",
  "SS": "Stainless Steel",
  "PS": "Poly Steel",
  "UNK": "Unknown",
  "OTH": "Other",
  "ABS": "Acrylonitrile butadiene styrene (ABS)",
  "GI": "Galvanized Iron",
  "AB3P": "Anti Bacteria 3",
  // "MPVC":"MPVC"
}